import React, { useEffect } from "react";
import { Message, Segment, TransitionablePortal } from "semantic-ui-react";
import { useRecoilState } from "recoil";
import { notificationState } from "../../atoms/notificationState";

function GlobalMessage() {
  const [notification, setNotification] = useRecoilState(notificationState);

  useEffect(() => {
    if (notification.show && notification.duration) {
      const timer = setTimeout(() => {
        setNotification((prev) => ({ ...prev, show: false }));
        return () => clearTimeout(timer);
      }, notification.duration);
    }
  }, [notification.duration, notification.show, setNotification]);

  const handleDismiss = () => {
    setNotification((prev) => ({ ...prev, show: false }));
  };

  const getMessageProps = () => {
    switch (notification.type) {
      case "success":
        return {
          color: "green",
          icon: "check",
        };
      case "warning":
        return {
          color: "yellow",
          icon: "warning",
        };
      case "error":
        return {
          color: "red",
          icon: "warning",
        };
      case "info":
        return {
          color: "blue",
          icon: "info",
        };
      default:
        return {
          color: "black",
          icon: "info",
        };
    }
  };

  return (
    <TransitionablePortal open={notification.show} transition={{ animation: "scale", duration: 300 }}>
      <Segment
        style={{
          position: "fixed",
          top: "10px",
          right: "10px",
          zIndex: 9999,
          margin: "0",
          padding: "0",
          minWidth: "300px",
          maxWidth: "500px",
          overflow: "auto",
        }}
      >
        <Message
          {...getMessageProps()}
          onDismiss={handleDismiss}
          header={notification.title}
          content={notification.message}
        />
      </Segment>
    </TransitionablePortal>
  );
}

export default GlobalMessage;
